#import "../fragments/broadcast-stub-fragment.graphql"

query GetBroadcasts(
    $limit: Int!
    $after: String
    $archived: Boolean!
    $sort: BroadcastSortType!
    $search: String
    $creatorUserId: String
    $lastUpdatedTime: String
    $statuses: [EditionStatus!]
    $assigneeIds: [ID!]
) {
    broadcasts(
        first: $limit
        after: $after
        archived: $archived
        sort: $sort
        search: $search
        creatorUserId: $creatorUserId
        modifiedSinceTime: $lastUpdatedTime
        statuses: $statuses
        assigneeIds: $assigneeIds
    ) {
        totalCount
        pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
        }
        edges {
            cursor
            node {
                ...BroadcastStubFragment
            }
        }
    }
}
